// extracted by mini-css-extract-plugin
module.exports = {"item":"BillItem_style_item__1hpDi","content":"BillItem_style_content__2Rciv","header":"BillItem_style_header__nMjZ2","refundRemark":"BillItem_style_refundRemark__31L5P"};